import { HexagonSize as View } from 'ui-components'
import { useMapSettingsStore } from '~map-preview/states/mapSettings'
import { Hexagon } from '~map-preview/types/__generated/gql/graphql'

import { useUpdateDefaultVisualization } from '~map-settings/hooks/useUpdateDefaultVisualization'

export const Size = (props) => {
  const { defaultVisualization } = useMapSettingsStore()
  const { update } = useUpdateDefaultVisualization()
  const handleChange = async (event, value) => {
    // Create a new object to avoid mutation
    const tmp = {
      ...defaultVisualization.hexagon, // Copy the hexagon properties
      size: value
    }
    await update(tmp)
  }

  const selected: Hexagon | undefined =
    defaultVisualization &&
    (Object.values(defaultVisualization)[0] as Hexagon | undefined)

  return (
    <View
      onChange={handleChange}
      value={selected?.size}
    />
  )
}
